const translations = {
  en: {
    manualRefresh: "Manual Refresh",
    dead: "❌ Dead",
    alive: "✅ Alive",
    code: "Code",
    builtBy: "Built by",
    checking: "Summoning API ghosts for",
    apiCheckComplete: "API check complete",
    timelineLog: "Timeline Log",
    lightMode: "Light Mode",
    darkMode: "Dark Mode",
    switchedTo: "Switched to",
    loading: "Summoning API ghosts...",
  },
  hi: {
    manualRefresh: "हाथ से ताज़ा करें",
    dead: "❌ मृत",
    alive: "✅ जीवित",
    code: "कोड",
    builtBy: "निर्माता",
    checking: "API आत्माओं को बुला रहे हैं",
    apiCheckComplete: "API जांच पूरी हुई",
    timelineLog: "समयरेखा लॉग",
    lightMode: "प्रकाश मोड",
    darkMode: "अंधकार मोड",
    switchedTo: "स्विच किया गया",
    loading: "API आत्माओं को बुलाया जा रहा है...",
  },
};

export default translations;

